module.exports = __webpack_public_path__ + "img/black38.957c63d7.png";